module.exports = "/_next/static/resources/sourcing-a0bab5b4dfb8884734d386110a4ea0cc.webp";